import { gql } from "@stadium/services/apollo-client";

export const DIGITAL_ASSET_CONTENT = gql`
  fragment DigitalAssetContent on DigitalAsset {
    id
    folderId
    kind
    url
    extension
    attachmentContentType
    attachmentFileSize
    attachmentFileName
    userAuthorized
    estimatedPrintQuality
  }
`;
